import React, { useState, useEffect } from 'react';
import styles from './Future.module.css';
import Future1 from '../../images/ambedkar.jpg';
import Future2 from '../../images/mathrubhumi.jpg';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const ArtGallery = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLoaded, setIsLoaded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 100);

    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const artworks = [
    { id: 1, image: Future1 },
    { id: 2, image: Future2 },
  ];

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      <div className={styles.artContainer}>

        {/* Animated Background */}
        <div className={styles.artBackground}>
          <div
            className={styles.gradientOrb + ' ' + styles.orb1}
            style={{
              transform: `translate(${mousePosition.x * 0.05}px, ${mousePosition.y * 0.05}px)`
            }}
          />
          <div
            className={styles.gradientOrb + ' ' + styles.orb2}
            style={{
              transform: `translate(${-mousePosition.x * 0.03}px, ${mousePosition.y * 0.03}px)`
            }}
          />
          <div
            className={styles.gradientOrb + ' ' + styles.orb3}
            style={{
              transform: `translate(${mousePosition.x * 0.04}px, ${-mousePosition.y * 0.04}px)`
            }}
          />
        </div>

        {/* Floating Particles */}
        <div className={styles.artParticles}>
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className={styles.particle}
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${15 + Math.random() * 10}s`
              }}
            />
          ))}
        </div>

        {/* Main Content */}
        <div className={`${styles.artContent} ${isLoaded ? styles.loaded : ''}`}>
          <header className={styles.artHeader}>
            <h1 className={styles.artTitle}>
              <span className={styles.titleLine}>Exploring Cultural Icons</span>
              <span className={`${styles.titleLine} ${styles.delay}`}>in Experimental Artistry</span>
            </h1>
            <div className={styles.titleDecoration} />
          </header>

          <article className={styles.artDescription}>
            <p className={styles.artParagraph}>
              Embarking on a journey of cultural reinterpretation, this series of experimental
              artworks delves into the intricate tapestry of Indian identity. Departing from the
              conventional portrayal of Indian currency featuring Ambedkar, this collection
              reimagines the rupee note, infusing it with vibrant narratives beyond monetary value.
            </p>
            <p className={styles.artParagraph}>
              Drawing inspiration from Kerala's renowned newspaper, Mathrubhumi, each piece
              celebrates significant dates through imaginative doodle works. Crafted meticulously
              using digital tools like Illustrator, Photoshop, and Procreate, the fusion of
              traditional symbolism with modern technology creates a captivating narrative of
              heritage and innovation.
            </p>
            <p className={`${styles.artParagraph} ${styles.highlight}`}>
              Explore the intersection of tradition and contemporary expression through these
              evocative visual narratives.
            </p>
          </article>

          {/* Gallery */}
          <section className={styles.artGallery}>
            {artworks.map((artwork, index) => (
              <div
                key={artwork.id}
                className={`${styles.artworkCard} ${styles[`card${index + 1}`]}`}
              >
                <div className={styles.cardInner}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={artwork.image}
                      alt="Artwork"
                      className={styles.artworkImage}
                      onClick={() => setSelectedImage(artwork.image)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </section>
        </div>

        {/* Image Modal */}
        {selectedImage && (
          <div className={styles.imageModal} onClick={() => setSelectedImage(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.closeButton} onClick={() => setSelectedImage(null)}>
                ×
              </button>
              <img src={selectedImage} alt="Full size artwork" className={styles.modalImage} />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default ArtGallery;